import { Outlet } from 'react-router-dom'
import { Box, Text, Container, Anchor } from '@mantine/core'
import { NavHeader } from '../common/NavHeader'

export function LandingLayout() {
  return (
    <Box style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <NavHeader />

      {/* Main content */}
      <Box component="main" style={{ flex: 1 }}>
        <Outlet />
      </Box>

      {/* Footer */}
      <Box
        component="footer"
        py="md"
        px="lg"
        style={{
          borderTop: '1px solid var(--bw-panel-border)',
          background: 'var(--bw-panel-bg)',
        }}
      >
        <Container size="lg">
          <Text size="xs" c="dimmed" ta="center">
            &copy; {new Date().getFullYear()}{' '}
            <Anchor href="https://www.bubotlearning.com" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--bw-accent)' }} size="xs">
              Bubot Learning
            </Anchor>
            . All rights reserved.
          </Text>
        </Container>
      </Box>
    </Box>
  )
}
